<ng-container>
    <ng-container [ngSwitch]="viewMode">
        <ng-container *ngSwitchCase="PanelViewMode.New" #newPanel>
            <create-survey-job (navigateTo)="goToList($event)"></create-survey-job>
        </ng-container>
        <ng-container *ngSwitchCase="PanelViewMode.Detail" #detailPanel>
            <survey-job-detail
                @fadeInOut
                [job]="selectedSurveyJob"
                (jobUpdated)="onJobUpdated($event)"
                (navigateTo)="navigateTo($event)"
            ></survey-job-detail>
        </ng-container>
        <ng-container *ngSwitchDefault>
            <!-- Job List Panel -->
            <div class="primary-panel">
                <div class="tools-bar">
                    <panel-header
                        [headerTitle]="'Survey.SurveyJobPanel.Jobs'"
                        [showBackButton]="false"
                        [actionItems]="headerActions"
                        [disabled]="loading"
                        (backClick)="closePanel()"
                        (actionClick)="handleAction($event)"
                    >
                    </panel-header>
                </div>

                <!-- Sort Menu -->
                <sort-menu
                    #surveyJobSortMenu
                    [menuItems]="sortMenuItems"
                    [selectedSortOption]="selectedSortOption"
                    [currentSortDirection]="currentSortDirection"
                    (sortChange)="onSortChange($event)"
                    (menuClosed)="onSortMenuClosed()"
                >
                </sort-menu>

                <div class="secondary-panel" @fadeInOut #secondaryPanel *ngIf="showFilterPanel">
                    <job-filter
                        [filterTitle]="'Survey.SurveyJobPanel.Filter' | translate"
                        class="filter-survey-task-job"
                        [fields]="filterFields"
                        [values]="surveyFilterValues"
                        (valuesChange)="onFilterPanelChange($event)"
                        (closeFilterPanel)="toggleFilterPanel()"
                    ></job-filter>
                </div>

                <div class="search" @slideOut *ngIf="showSearch">
                    <gsp-text
                        [placeholder]="searchPlaceholder"
                        [clearable]="true"
                        class="fw gsp-form-input"
                        [(ngModel)]="searchInput"
                        (ngModelChange)="onSearchInputChangeDebounce($event)"
                    ></gsp-text>
                </div>

                <div class="filter" @slideOut *ngIf="filterAppliedCount > 0">
                    <div class="filter-applied">
                        <i class="modus-icons">filter</i>
                        <span>{{ 'Survey.SurveyJobPanel.Filter.FilterApplied' | translate }}</span>
                        <gsp-button
                            [type]="ButtonType.Icon"
                            [iconClass]="'modus-icons i16'"
                            [modusIcon]="'close'"
                            (click)="clearFilter()"
                            title="{{ 'TCW_Clear_Filters' | translate }}"
                        ></gsp-button>
                    </div>
                </div>

                <tabbed-list
                    [tabs]="tabs"
                    [tabIndex]="tabIndex"
                    [loading]="loading"
                    [listItems]="surveyJobs"
                    [allItemsLoaded]="allItemsLoaded"
                    [currentScrollPosition]="currentScrollPosition"
                    (loadNextPage)="onLoadNextPage()"
                    (tabIndexChange)="onTabChange($event)"
                    (selectSurveyJob)="selectSurveyJob($event)"
                    (jobVisibilityToggle)="onJobVisibilityToggle($event)"
                ></tabbed-list>
            </div>
        </ng-container>
    </ng-container>
</ng-container>
